import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography } from '../../atoms';
import { styled } from '../../legacy/utils';
export const SingleTab = ({ tab }) => {
    return (_jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", children: [_jsx(Typography, { variant: "h5", color: "darkBlue", children: tab.header }), _jsxs(StyledStack, { direction: "row", alignItems: "center", children: [_jsx(TypoStyled, { variant: "h5", color: "darkBlue", children: tab.text }), tab.isEditable && (_jsx(Button, { onClick: tab.onEdit, variant: "text", icon: "pencil" }))] })] }));
};
const StyledStack = styled(Stack)(({ theme }) => ({
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        width: '100%',
    },
}));
const TypoStyled = styled(Typography)(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        fontSize: '1.375rem',
    },
}));
